import { render, staticRenderFns } from "./ColorSwitch.vue?vue&type=template&id=7d944808&scoped=true&"
import script from "./ColorSwitch.vue?vue&type=script&lang=js&"
export * from "./ColorSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ColorSwitch.vue?vue&type=style&index=0&id=7d944808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d944808",
  null
  
)

export default component.exports